import * as yup from 'yup';

const useValidationSchema = () => {
  const RSAFormSchema = yup.object();
  return { RSAFormSchema };
};

export default useValidationSchema;
